module.exports = __webpack_public_path__ + "static/media/info-icon.a8449a63.svg";